import {defaultTooltipOptions, defaultYAxisScale, gridColor, labelColor} from '../chart-const';

import {ChartJsLineOptionsType} from './line-chart-type';

export const defaultLineChartOptions: ChartJsLineOptionsType = {
    maintainAspectRatio: false,
    scales: {
        x: {
            border: {
                display: false,
            },
            type: 'category',
            grid: {
                color: gridColor,
                drawOnChartArea: true,
                drawTicks: false,
            },
            ticks: {
                color: labelColor,
                padding: 10,
            },
        },
        y: defaultYAxisScale,
    },
    plugins: {
        legend: {
            display: true,
            align: 'start',
            labels: {
                boxWidth: 16,
                boxHeight: 16,
            },
        },
        tooltip: defaultTooltipOptions,
        datalabels: {
            display: false,
        },
    },
};
